export { default } from './outsideAlerter';